<template>
  <v-row justify="center">
    <v-dialog
      class="signinmodal"
      :value="value"
      v-on:input="$emit('input', $event.target.value)"
      persistent
      max-width="340px"
    >
      <v-card class="ma-0 pa-0">
        <signin :forceemail="email" @success="onSuccess">
          <template slot="text">
            You were signed out, please sign in through the same account to pick
            up where you left off.
          </template>
          <template v-slot:actions="{ on, disabled }">
            <v-card-actions>
              <v-btn
                text=""
                color="red"
                min-width="80px"
                depressed
                @click="signOut"
                >Leave page</v-btn
              >
              <v-spacer></v-spacer>
              <v-btn
                :disabled="disabled"
                color="primary"
                min-width="100px"
                type="submit"
                depressed
                v-on="on"
                >Sign in</v-btn
              >
            </v-card-actions>
          </template>
        </signin>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<style scoped>
.signinmodal {
  z-index: 500 !important;
}
</style>
<script>
import signin from "@/components/signin";
export default {
  props: ["value"],
  components: {
    signin
  },
  methods: {
    onSuccess() {
      this.$emit("input", false);
    },
    signOut() {
      if (
        confirm(
          "Are you sure you want to sign out?\n\nIf you accept you will be redirected from the current page, your unsaved work will be lost. "
        )
      ) {
        window.location.href = "/";
      } else {
        return;
      }
    }
  },
  computed: {
    email() {
      if (
        !this.$store.getters.getAWSUser ||
        !this.$store.getters.getAWSUser.attributes ||
        !this.$store.getters.getAWSUser.attributes.email
      ) {
        return "";
      }
      return this.$store.getters.getAWSUser.attributes.email;
    }
  }
};
</script>

<style></style>
